import AdminComponent from "@/components/dashboard/AdminComponent";

import GrossProductSearch from "@/views/search/GrossProductSearch";
import GrossProductCreate from "@/views/create/GrossProductCreate";
import GrossProductUpdate from "@/views/update/GrossProductUpdate";

export default {
    path: "/gross-product",
    meta: {auth: true},
    component: AdminComponent,
    children: [
        {path: "search", name: "gross-product-search", component: GrossProductSearch},
        {path: "create", name: "gross-product-create", component: GrossProductCreate},
        {path: "edit/:id", name: "gross-product-edit", component: GrossProductUpdate, props: true},
    ]
}
